import React from "react";
import { Outlet } from "react-router-dom";
import { baseConfig } from "../../config";
import SideBar from "../SideBar"; // Corrigido o import
import Header from "../Header";
import Footer from "../Footer";
import "./Layout.css";

const Layout = () => {
  return (
    <div className="layout-container">
      {baseConfig.header ? <Header /> : null}
      <SideBar />

      <div className="page-container">
        <Outlet />
      </div>

      {baseConfig.footer ? <Footer /> : null}
    </div>
  );
};

export default Layout;
